/**
 * Function that transform french number with internationnal code (0033, +33) into
 * base french number. Removes also all special chars.
 *
 * @param phoneNumber string
 * @returns string
 */
export const formatPhoneNumber = (phoneNumber: string | null | undefined): string | null => {
    // Check if null or undefined
    if (phoneNumber === null || phoneNumber === undefined) {
        return null;
    }
    // Remove all special chars and spaces except '+'
    const cleanedNumber = phoneNumber.replace(/[.\-\s]/g, '');
    let formatedNumber;

    // check if number start with a code
    if (cleanedNumber.length > 10) {
        // Handle +33
        if (cleanedNumber.substring(0, 3) === '+33') {
            formatedNumber = `0${cleanedNumber.substring(3)}`;

            // Handle 0033
        } else if (cleanedNumber.substring(0, 4) === '0033') {
            formatedNumber = `0${cleanedNumber.substring(4)}`;
            // Return error if not one of previous code
        } else {
            throw new Error('Format de numéro de téléphone non reconnu');
        }
    } else if (cleanedNumber.length === 10 && cleanedNumber[0] === '0') {
        formatedNumber = cleanedNumber;
    } else {
        throw new Error('Format de numéro de téléphone inconnu');
    }

    return formatedNumber;
};
